import { OverlayUtil } from "@tldraw/editor";
class CollaboratorBrushOverlayUtil extends OverlayUtil {
  static type = "collaborator_brush";
  options = { zIndex: 700, lineWidth: 1 };
  isActive() {
    return this.editor.getVisibleCollaboratorsOnCurrentPage().some((c) => c.brush !== null);
  }
  getOverlays() {
    const overlays = [];
    for (const presence of this.editor.getVisibleCollaboratorsOnCurrentPage()) {
      const { brush, color, userId } = presence;
      if (!brush) continue;
      overlays.push({
        id: `collaborator_brush:${userId}`,
        type: "collaborator_brush",
        props: {
          x: brush.x,
          y: brush.y,
          w: Math.max(1, brush.w),
          h: Math.max(1, brush.h),
          color
        }
      });
    }
    return overlays;
  }
  render(ctx, overlays) {
    const zoom = this.editor.getZoomLevel();
    for (const overlay of overlays) {
      const { x, y, w, h, color } = overlay.props;
      ctx.globalAlpha = 0.075;
      ctx.fillStyle = color;
      ctx.fillRect(x, y, w, h);
      ctx.globalAlpha = 0.1;
      ctx.strokeStyle = color;
      ctx.lineWidth = this.options.lineWidth / zoom;
      ctx.strokeRect(x, y, w, h);
      ctx.globalAlpha = 1;
    }
  }
  renderMinimap(ctx, overlays) {
    for (const overlay of overlays) {
      const { x, y, w, h, color } = overlay.props;
      ctx.globalAlpha = 0.75;
      ctx.fillStyle = color;
      ctx.fillRect(x, y, w, h);
    }
    ctx.globalAlpha = 1;
  }
}
export {
  CollaboratorBrushOverlayUtil
};
//# sourceMappingURL=CollaboratorBrushOverlayUtil.mjs.map
